import { ProposalConfig } from '../../Pricing/proposalConfig';
import validate from '../../../../../base-ui/utils/validate.js';

const verifyProposalConfig = (
	config: ProposalConfig,
	totalCost?: number
): string | null => {
	const signer1 = config.signers[0];
	const signer2 = config.signers[1];

	if (!signer1?.name || !signer1.name.trim().length) {
		return '1st signer name is required';
	}

	if (!signer1?.email || !signer1.email.trim().length) {
		return '1st signer email is required';
	}

	if (!validate.email(signer1.email)) {
		return '1st signer email is invalid';
	}

	if (config.secondSigner) {
		if (!validate.email(signer2.email)) {
			return '2nd signer email is invalid';
		}

		if (!signer2?.name || !signer2.name.trim().length) {
			return '2nd signer name is required';
		}

		if (!signer2?.email || !signer2.email.trim().length) {
			return '2nd signer email is required';
		}
	}

	if (config.includePaymentSchedule) {
		console.log(config.includePaymentSchedule);
		const schedule = config.paymentSchedule ?? [];

		if (schedule.length === 0) {
			return 'At least one payment schedule milestone is required';
		}

		if (schedule.some((m) => !m.description?.trim()?.length)) {
			return 'All payment schedules must have a description';
		}

		const usesAmounts = schedule.some((milestone) => milestone.type === '$');

		if (usesAmounts && typeof totalCost === 'number') {
			const AMOUNT_TOLERANCE = 0.01;

			const totalAmount = schedule.reduce((acc, current) => {
				if (current.type === '$') {
					return acc + Number(current.percentage || 0);
				}
				// Convert percentage to amount
				return acc + (Number(current.percentage || 0) / 100) * totalCost;
			}, 0);

			const roundedTotalAmount = Math.round(totalAmount * 100) / 100;
			const difference = Math.abs(roundedTotalAmount - totalCost);

			if (difference > AMOUNT_TOLERANCE) {
				if (roundedTotalAmount < totalCost) {
					const amountShort = totalCost - roundedTotalAmount;
					return `Total payment schedule milestones should equal $${totalCost.toFixed(2)}. Currently, the schedule falls short by $${amountShort.toFixed(2)}.`;
				} else {
					const amountOver = roundedTotalAmount - totalCost;
					return `Total payment schedule milestones should equal $${totalCost.toFixed(2)}. Currently, the schedule exceeds by $${amountOver.toFixed(2)}.`;
				}
			}
		} else {
			// Percentage-only validation
			const PERCENTAGE_TOLERANCE = 0.1;
			const totalPercentage = schedule.reduce(
				(sum, milestone) => sum + Number(milestone.percentage || 0),
				0
			);

			const roundedTotalPercentage = Math.round(totalPercentage * 100) / 100;

			if (Math.abs(roundedTotalPercentage - 100) > PERCENTAGE_TOLERANCE) {
				if (roundedTotalPercentage < 100) {
					const percentageShort = 100 - roundedTotalPercentage;
					return `Total payment schedule milestones should equal 100%. Currently, the schedule falls short by ${percentageShort.toFixed(2)}%.`;
				} else {
					const percentageOver = roundedTotalPercentage - 100;
					return `Total payment schedule milestones should equal 100%. Currently, the schedule exceeds by ${percentageOver.toFixed(2)}%.`;
				}
			}
		}
	}

	if (config.includeCustomNotes && !config.notes?.trim()?.length) {
		return 'Notes cannot be empty';
	}

	return null;
};

export default verifyProposalConfig;
